import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, SxProps, TextField, Theme } from "@mui/material";
import React from "react";

export interface SearchBarProps {
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
  text?: string;
  requestSearch: (text: string) => any;
  updateSearchText?: (text: string) => any;
}

/**
 * A search bar, with a configurable action (requestSearch) when the search text changes.
 */
export function SearchBar(props: SearchBarProps) {
  const { fullWidth, requestSearch, sx, text, updateSearchText } = props;

  function executeSearch(event: any) {
    if (event.key === "Enter") {
      requestSearch(event.target.value);
    }
  }

  return (
    <TextField
      fullWidth={fullWidth}
      InputProps={{
        startAdornment: <SearchIcon fontSize="small" />,
        endAdornment: (
          <IconButton
            aria-label="Clear"
            size="small"
            style={{ visibility: text?.length ? "visible" : "hidden" }}
            title="Clear"
            onClick={() => {
              requestSearch("");
            }}
          >
            <ClearIcon fontSize="small" />
          </IconButton>
        ),
      }}
      sx={sx}
      placeholder="Search ..."
      variant="outlined"
      value={text}
      onKeyPress={(event: any) => executeSearch(event)}
      onChange={(event) => (updateSearchText ? updateSearchText(event.target.value) : undefined)}
    />
  );
}
